<template>
    <div>
        <app-sub-title text="Personas" />

        <b-row v-if="!isVigilance">

            <b-col xs="12" md="6" v-if="canSelectClient">
                <app-autocomplete
                    placeholder="Clientes"
                    :items="clients"
                    v-model="selectClient"
                    @change="startLoadPeople"
                />
            </b-col>
            <b-col cols="12" md="6" lg="3">
                <button :disabled="!selectClient" class="btn btn-primary btn-block" @click="startSavePerson()">
                    <i class="fa fa-user-plus"></i> Crear nueva persona
                </button>
            </b-col>
        </b-row>
        <b-row v-if="isVigilance">
            <b-col cols="12" sm="6" md="4">
                <button :disabled="!selectClient" class="btn btn-primary btn-block" @click="startSavePerson()">
                    <i class="fa fa-user-plus"></i> Crear nueva persona
                </button>
            </b-col>
        </b-row>


        <div class="filters" v-if="!!this.selectClient">
            <app-sub-title text="Filtros" />
            <div class="card">
                <div class="card-body">
                    <div class="card-text">
                        <b-row>
                            <b-col cols="12" md="6" lg="3">
                                <app-form-text-input placeholder="Estructura" v-model="filters.structure" />
                            </b-col>
                            <b-col cols="12" md="6" lg="3">
                                <app-form-text-input placeholder="Nombre" v-model="filters.name" />
                            </b-col>
                            <b-col cols="12" md="6" lg="2">
                                <app-form-text-input placeholder="Documento" v-model="filters.document" />
                            </b-col>
                            <b-col cols="12" md="6" lg="2">
                                <app-form-select-input
                                    placeholder="Interno"
                                    :options="optionsInternal"
                                    v-model="filters.internal"
                                />
                            </b-col>
                            <b-col cols="12" md="6" lg="2">
                                <app-form-text-input placeholder="Cargo" v-model="filters.position" />
                            </b-col>


                        </b-row>
                        <b-row align-h="between">
                            <b-col cols="12" md="6" lg="2">
                                <app-form-text-input placeholder="Notas" v-model="filters.notes" />
                            </b-col>
                            <b-col cols="12" md="auto" class="d-flex justify-content-end">
                                <b-btn variant="primary" size="sm" @click="searchPeople">
                                    &nbsp;<i class="fa fa-filter"></i>&nbsp;
                                </b-btn>
                                <b-btn size="sm" @click="cancelFilter" si class="ml-2">
                                    &nbsp;<i class="fa fa-times-circle"></i>&nbsp;
                                </b-btn>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </div>
        <app-table-people v-if="!!this.selectClient"
            :data="data"
            :on-change-page="onChangePage"
            :see-card="seeCard"
            :update-person="startUpdate"
            :remove-person="startRemove"
            @sort="onSort"
        />

        <!-- inicio de pop ups -->

        <app-pop-up title="Confirmación" id="person-remove">
            <div slot="body">
                <h2>¿Esta seguro que desea eliminar esta persona?</h2>
            </div>
            <div class="buttons" slot="buttons">
                <button class="btn btn-confirm" @click="deletePerson(selectPerson)">
                    <i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar Eliminación</button>
            </div>

        </app-pop-up>

        <app-pop-up title="Formulario de persona" id="person-form" :onClose="cleanForm" size="large">
            <div class="body" slot="body">
                <app-people-form-page v-if="!!selectClient" :my-person="selectPerson" :my-client="selectClient" :onSave="onSave"></app-people-form-page>

            </div>
            <div slot="buttons">
                <button class="btn btn-confirm" :disabled="inProgress" @click="$bus.$emit('person-form.save')"> Guardar</button>
            </div>
        </app-pop-up>

        <app-pop-up title="Tarjeta de persona" id="person-card" :onClose="cleanCard" size="extra-large">
            <div class="body" slot="body">
                <app-person-card :person="selectPerson" :client-id="selectClient.id" v-if="selectPerson"></app-person-card>
            </div>
            <div slot="buttons">

            </div>
        </app-pop-up>

        <!-- fin de pop ups -->
    </div>
</template>
<script>
    import PeopleRepository from '../../../repositories/people.repository.js';
    import PeopleFormPage from '../People/PeopleFormPage.vue';
    import PersonCard from '../../Clients/PersonCard/PersonCard.vue';
    import TablePeople from './TablePeople/TablePeople.vue';
    import { required } from 'vuelidate/lib/validators';
    import { pagination } from '../../../mixin';
    // import Autocomplete from '../../UI/Controls/AutocompleteV2/Autocomplete';
    import { mapGetters } from 'vuex';
    export default {
        mixins: [pagination],
        components: {
            appPeopleFormPage: PeopleFormPage,
            appPersonCard: PersonCard,
            // appAutocomplete: Autocomplete,
            appTablePeople: TablePeople
        },
        data() {
            return {
                page: 1,
                selectPerson: '',
                selectClient: '',
                selectedClient: null,
                filters: {
                    structure: '',
                    name: '',
                    document: '',
                    internal:'',
                    position: '',
                    notes: '',
                },
                optionsInternal: [
                    {id: 1, name: 'SI'},
                    {id: 0, name: 'NO'}
                ],
                isVigilance: false,
                isClient: false,
                data: {},
                sort: {
                    sortBy: 'name',
                    sortDir: 'asc'
                }
            };
        },
        validations: {
            selectClient: {
                required
            }
        },
        watch: {

        },
        computed: {
            ...mapGetters(['clients']),
            canSelectClient() {
                if(this.user.profile.client_side)
                    return false;

                if(this.user.profile.client_required)
                    return false;

                return true;
            }
        },
        methods: {
            onSave() {
                this.$bus.$emit('person-form.close');
                this.loadPeople(this.selectClient.id);
            },
            cleanForm() {
                this.$bus.$emit('person-form.clean');
            },
            cleanCard(){
                this.$bus.$emit('person-card.clean');
                this.$bus.$emit('person-entry-history.clean');
            },
            startLoadPeople() {
                if(!this.selectClient) return;
                this.$v.selectClient.$touch();
                this.loadPeople(this.selectClient.id);
            },
            searchPeople(){
                this.page = 1;
                this.loadPeople(this.selectClient.id);
            },
            async loadPeople(clientId) {
                try {
                    this.$v.$touch();
                    if (this.$v.$invalid) {
                        return false;
                    }

                    const filters = {...this.filters, sortBy: this.sort.sortBy, sortDir: this.sort.sortDir };

                    const pr = Object.assign({}, PeopleRepository);
                    const {data} = await pr.searchPeopleOfClient(clientId, this.page, filters)
                    this.data = data;
                } catch (error) {
                    toastr.error(error)
                }
            },
            onChangePage(page){
                this.page = page;
                this.loadPeople(this.selectClient.id);
            },
            deletePerson(person) {
                const pr = Object.assign({}, PeopleRepository);
                pr
                    .deletePerson(person.id, this.user.id)
                    .then(data => {
                        if (data.status) {
                            toastr.success(data.msg);
                            this.loadPeople(this.selectClient.id);
                            this.$bus.$emit('person-remove.close');
                        } else {
                            toastr.error(data.msg);
                        }
                    })
                    .catch(error => {
                        toastr.error("No se pudo borrar la persona");
                    });
            },
            startRemove(person) {
                this.selectPerson = person;
                this.$bus.$emit('person-remove.open');
            },
            startUpdate(person) {
                this.selectPerson = Object.assign({}, person);
                this.$bus.$emit('person-form.open');
            },
            startSavePerson() {
                this.selectPerson = '';
                this.$bus.$emit('person-form.open');
            },
            seeCard(person){
                this.selectPerson = person;
                this.$bus.$emit('person-card.open');
            },
            cancelFilter() {
                this.page = 1;
                Object.keys(this.filters).map(key => this.filters[key] = '');
                this.loadPeople(this.selectClient.id);
            },
            onSort(ctx) {
                this.sort.sortBy = ctx.sortBy;
                this.sort.sortDir = ctx.sortDir;
                this.loadPeople(this.selectClient.id);
            }
        },

        created() {
            this.load('clients');
            this.isVigilance = !!this.user.profile.client_required;
            this.isClient = !!this.user.profile.client_side;
            if(this.isVigilance){
                this.selectClient = this.client;
                this.startLoadPeople();
            }
            if(this.isClient){
                this.selectClient = this.client;
                this.startLoadPeople();
            }
        }
    };
</script>
